import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import WrapperSlider from './wrapperSlider/WrapperSlider'

const configureDfpTargeting = (dfpAccount, sliders, campaignId, catalogId, clientId, sliderIsOnlyCash) =>
  sliders.map(slider => ({
    accountDfp: dfpAccount,
    sliderName: slider,
    sizeMapping: [
      { viewport: [0, 0], slot: [375, 310] },
      { viewport: [475, 0], slot: [1366, 450] }
    ],
    targeting: {
      ltm_campaign: [campaignId, 'default'],
      ltm_catalog: [catalogId, 'default'],
      ltm_costumer: [clientId],
      only_cash: [sliderIsOnlyCash]
    }
  }))

const SliderContainer = ({ profile, google, onlyCash, catalogJustCash }) => {
  const sliders = [
    'ragnarok_1',
    'ragnarok_2',
    'ragnarok_3',
    'ragnarok_4',
    'ragnarok_5',
    'ragnarok_6',
    'ragnarok_7',
    'ragnarok_8',
    'ragnarok_9',
    'ragnarok_10'
  ]
  const campaignId = profile ? profile['custom:campaign_id'] : '0'
  const catalogId = profile ? profile['custom:catalog_id'] : process.env.REACT_APP_CATALOG_ID
  const clientId = profile ? profile['custom:client_id'] : '0'
  const sliderIsOnlyCash = catalogJustCash ? onlyCash.toString() : 'false'

  const sliderList = configureDfpTargeting(google.accountDfp, sliders, campaignId, catalogId, clientId, sliderIsOnlyCash)

  const options = {
    autoHeight: true,
    items: 1,
    nav: true,
    rewind: !profile,
    autoplay: true,
    navClass: [
      'pos-absolute slider-nav showcase-nav showcase-next bg-featured d-none d-md-block border-color-brand-1 btn-icon',
      'pos-absolute slider-nav showcase-nav showcase-prev bg-featured d-none d-md-block border-color-brand-1 btn-icon'
    ],
    navText: [
      '<i className="icon icon_right color-ui-white"></i>',
      '<i className="icon icon_left color-ui-white"></i>'
    ]
  }

  return <WrapperSlider sliders={sliderList} options={options} />
}

SliderContainer.propTypes = {
  profile: PropTypes.shape({
    'custom:campaign_id': PropTypes.string.isRequired,
    'custom:catalog_id': PropTypes.string.isRequired,
    'custom:client_id': PropTypes.string.isRequired
  }),
  google: PropTypes.shape({
    accountDfp: PropTypes.string.isRequired
  }),
  catalogJustCash: PropTypes.bool,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ oidc: { user }, google, catalog, onlyCash }) => ({
  profile: user && user.profile,
  google,
  catalogJustCash: catalog.onlyCash,
  onlyCash
})

export default connect(mapStateToProps)(SliderContainer)



// WEBPACK FOOTER //
// ./src/features/Slider/SliderContainer.js